/**
 * 音声表示区分定義
 */
export class AudioViewTypes {
  // 表示区分1
  // 「一時停止制御」OFF、「インジケータ制御」OFF、「再再生制御（可否）」否
  static readonly VT1: AudioViewType = {
    num: 1,
    setting: {
      availablePause: false,
      showIndicator: false,
      availableReplay: false,
    },
  }
  // 表示区分2
  // 「一時停止制御」ON、「インジケータ制御」OFF、「再再生制御（可否）」否
  static readonly VT2: AudioViewType = {
    num: 2,
    setting: {
      availablePause: true,
      showIndicator: false,
      availableReplay: false,
    },
  }
  // 表示区分3
  // 「一時停止制御」ON、「インジケータ制御」ON、「再再生制御（可否）」否
  static readonly VT3: AudioViewType = {
    num: 3,
    setting: {
      availablePause: true,
      showIndicator: true,
      availableReplay: false,
    },
  }
  // 表示区分4
  // 「一時停止制御」ON、「インジケータ制御」ON、「再再生制御（可否）」可
  static readonly VT4: AudioViewType = {
    num: 4,
    setting: {
      availablePause: true,
      showIndicator: true,
      availableReplay: true,
    },
  }
  // 表示区分5
  // 「一時停止制御」OFF、「インジケータ制御」ON、「再再生制御（可否）」否
  static readonly VT5: AudioViewType = {
    num: 5,
    setting: {
      availablePause: false,
      showIndicator: true,
      availableReplay: false,
    },
  }
  // 表示区分6
  // 「一時停止制御」OFF、「インジケータ制御」ON、「再再生制御（可否）」可
  static readonly VT6: AudioViewType = {
    num: 6,
    setting: {
      availablePause: false,
      showIndicator: true,
      availableReplay: true,
    },
  }
  // 表示区分7
  // 「一時停止制御」OFF、「インジケータ制御」OFF、「再再生制御（可否）」可
  static readonly VT7: AudioViewType = {
    num: 7,
    setting: {
      availablePause: false,
      showIndicator: false,
      availableReplay: true,
    },
  }
  // 表示区分8
  // 「一時停止制御」ON、「インジケータ制御」OFF、「再再生制御（可否）」可
  static readonly VT8: AudioViewType = {
    num: 8,
    setting: {
      availablePause: true,
      showIndicator: false,
      availableReplay: true,
    },
  }
  // 表示区分一覧
  static readonly LIST = [
    AudioViewTypes.VT1,
    AudioViewTypes.VT2,
    AudioViewTypes.VT3,
    AudioViewTypes.VT4,
    AudioViewTypes.VT5,
    AudioViewTypes.VT6,
    AudioViewTypes.VT7,
    AudioViewTypes.VT8,
  ]

  // 区分番号で取得
  static findByNum(num: number): AudioViewType | undefined {
    return AudioViewTypes.LIST.find((type) => {
      return type.num === num
    })
  }
}

export type AudioViewType = {
  // 区分番号
  num: number
  // 制御設定
  setting: AudioViewSetting
}

export type AudioViewSetting = {
  // 一時停止制御
  availablePause: boolean
  // インジケータ制御
  showIndicator: boolean
  // 再再生制御（可否）
  availableReplay: boolean
}
